var map = {
	"./Headphone2.svg": 8766,
	"./Headphone3.svg": 8756,
	"./alive.jpg": 4573,
	"./apocalypse-1600776027-tsCmgK4gEU.jpg": 4890,
	"./avatar.jpg": 9623,
	"./avatar2.jpg": 5956,
	"./background.svg": 6359,
	"./headphones.svg": 6485,
	"./ignite-1600419626-nHn4WXY79q.jpg": 5952,
	"./left.svg": 8430,
	"./logo.png": 2603,
	"./logo1.png": 2027,
	"./notAvailable.jpg": 4371,
	"./over-my-head-1602154826-mOiKzOJDe6.jpg": 4291,
	"./right.svg": 7695,
	"./searchMusic.svg": 797,
	"./searchMusicDisc.svg": 4634,
	"./searchMusicMp3.svg": 7103,
	"./shakedown.jpg": 2140,
	"./want-you-feat-sara-skinner-1586956276-s4lOrfrHQj.jpg": 2876
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 659;